export const pickRandomlyFromArray = (array) => {
  if (!array || !array?.length) return undefined
  const random = Math.floor(Math.random() * array.length);
  return array[random]
}